<template>
  <div
    class="modal fade"
    ref="historyModal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">歷史紀錄</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            X
          </button>
        </div>
        <div class="modal-body">
          <table class="table table-bordered table-hover">
            <thead>
              <tr class="tr-bg">
                <th scope="col" class="text-nowrap" style="width: 20%">日期</th>
                <th scope="col" class="text-nowrap" style="width: 60%">
                  專案名稱
                </th>
                <th scope="col" class="text-nowrap" style="width: 20%">狀態</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in historyData" :key="index">
                <td class="text-nowrap">{{ getCaseDate(data) }}</td>
                <td class="text-truncate" style="max-width: 0">
                  <a
                    class="btn"
                    :href="caseUrl.replace('__id', data.id)"
                    target="_blank"
                    style="min-width: 100%; text-align: left"
                    >{{ data.project_name }}</a
                  >
                </td>
                <td class="text-truncate" style="max-width: 0">
                  {{ data.signup ? "委任" : "諮詢" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn clear-btn" data-dismiss="modal">
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    historyData: {
      type: Array,
      default: () => [],
    },
    caseUrl: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getCaseDate(data) {
      if (data.signup) {
        return data.signup;
      }
      if (data.take_date) {
        return data.take_date;
      }
      return "";
    },
  },
  mounted() {
    this.$emit("input", new bootstrap.Modal(this.$refs.historyModal));
  },
};
</script>